import React, { useState } from "react";
import { useHistory, useParams } from "react-router-dom"; // For React Router v5
import axios from "axios";
import config from "./config";
import Footer from "./Footer";
import Tracking from "../assets/tracking.png";
import Navbar from "./Navbar";

const ReservationCheck = () => {
  const { id } = useParams();
  const [orderNo, setOrderNo] = useState(id || "");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const history = useHistory(); // For navigation

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const response = await axios.get(
        `${config.baseUrl}/api-v2/reservation/track?orderNo=${orderNo}&email=${email}`
      );

      // If reservation is found, navigate to the details page with the parameters
      if (response.data.success) {
        history.push(`/reservation/${orderNo}/${email}`);
      } else {
        setError(response.data.message);
      }
    } catch (err) {
      console.log(err);
      setError(
        err.response?.data?.message || "An error occurred. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  console.log(orderNo, email, "fffff");
  return (
    <div className="flex flex-col min-h-screen bg-[#C4C4C4]">
      <div className="flex-grow">
        <Navbar />
        <div className="mx-auto max-w-md py-8 px-4 flex flex-col justify-center items-center space-y-2">
          <img src={Tracking} alt="" className="w-64" />
          <h1 className="text-2xl font-bold">TRACK YOUR BOOKING</h1>
          <p className="text-center">
            Please enter following details to view your booking summary and
            track status of your booking.
          </p>
          <form onSubmit={handleSubmit} className="w-full space-y-3">
            <div className="grid grid-cols-1">
              <input
                id="order_number"
                name="order_number"
                type="text"
                placeholder="Enter Your Booking Number"
                value={orderNo}
                autoComplete="off"
                onChange={(e) => setOrderNo(e.target.value)}
                required
                className="col-start-1 appearance-none row-start-1 block w-full rounded-md bg-white py-1.5 pr-3 pl-10 text-base text-gray-900 placeholder:text-gray-400 focus:outline-none sm:pl-9 sm:text-sm/6"
              />
              <div className="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-gray-400 sm:size-4">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.9231 0.923077H13.3846V0.692308C13.3846 0.508696 13.3117 0.332605 13.1818 0.202772C13.052 0.0729393 12.8759 0 12.6923 0C12.5087 0 12.3326 0.0729393 12.2028 0.202772C12.0729 0.332605 12 0.508696 12 0.692308V0.923077H6V0.692308C6 0.508696 5.92706 0.332605 5.79723 0.202772C5.66739 0.0729393 5.4913 0 5.30769 0C5.12408 0 4.94799 0.0729393 4.81816 0.202772C4.68832 0.332605 4.61538 0.508696 4.61538 0.692308V0.923077H2.07692C1.52609 0.923077 0.997815 1.14189 0.608317 1.53139C0.218818 1.92089 0 2.44917 0 3V15.9231C0 16.4739 0.218818 17.0022 0.608317 17.3917C0.997815 17.7812 1.52609 18 2.07692 18H15.9231C16.4739 18 17.0022 17.7812 17.3917 17.3917C17.7812 17.0022 18 16.4739 18 15.9231V3C18 2.44917 17.7812 1.92089 17.3917 1.53139C17.0022 1.14189 16.4739 0.923077 15.9231 0.923077ZM16.6154 15.9231C16.613 16.1059 16.5393 16.2807 16.41 16.41C16.2807 16.5393 16.1059 16.613 15.9231 16.6154H2.07692C1.89406 16.613 1.71935 16.5393 1.59003 16.41C1.46071 16.2807 1.38701 16.1059 1.38462 15.9231V7.84615H16.6154V15.9231ZM16.6154 6.46154H1.38462V3C1.38701 2.81713 1.46071 2.64243 1.59003 2.51311C1.71935 2.38379 1.89406 2.31008 2.07692 2.30769H4.61538V2.53846C4.61538 2.72207 4.68832 2.89816 4.81816 3.028C4.94799 3.15783 5.12408 3.23077 5.30769 3.23077C5.4913 3.23077 5.66739 3.15783 5.79723 3.028C5.92706 2.89816 6 2.72207 6 2.53846V2.30769H12V2.53846C12 2.72207 12.0729 2.89816 12.2028 3.028C12.3326 3.15783 12.5087 3.23077 12.6923 3.23077C12.8759 3.23077 13.052 3.15783 13.1818 3.028C13.3117 2.89816 13.3846 2.72207 13.3846 2.53846V2.30769H15.9231C16.1059 2.31008 16.2807 2.38379 16.41 2.51311C16.5393 2.64243 16.613 2.81713 16.6154 3V6.46154ZM5.74154 11.7692C5.66489 11.6344 5.63573 11.4778 5.65871 11.3244C5.68169 11.1711 5.7555 11.0299 5.8683 10.9235C5.98109 10.8171 6.12635 10.7516 6.28078 10.7376C6.43522 10.7236 6.58989 10.7618 6.72 10.8462L8.07692 12.1754L10.3569 9.92308C10.487 9.83872 10.6417 9.80048 10.7961 9.8145C10.9506 9.82852 11.0958 9.89398 11.2086 10.0004C11.3214 10.1068 11.3952 10.248 11.4182 10.4014C11.4412 10.5547 11.412 10.7114 11.3354 10.8462L8.56615 13.6154C8.43635 13.745 8.26039 13.8179 8.07692 13.8179C7.89346 13.8179 7.7175 13.745 7.58769 13.6154L5.74154 11.7692Z"
                    fill="#515151"
                  />
                </svg>
              </div>
            </div>
            <div className="grid grid-cols-1 mt-2">
              <input
                id="email_address"
                name="email_address"
                type="email"
                autoComplete="off"
                placeholder="Enter Your Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-3 pl-10 text-base text-gray-900 focus:outline-none placeholder:text-gray-400 sm:pl-9 sm:text-sm/6"
              />
              <div className="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-gray-400 sm:size-4">
                <svg
                  width="18"
                  height="14"
                  viewBox="0 0 18 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.41964 8.11664C9.17057 8.294 8.82944 8.294 8.58036 8.11664L1.40625 3.00853V2.01923C1.40625 1.64751 1.72106 1.34615 2.10938 1.34615H15.8906C16.2789 1.34615 16.5938 1.64751 16.5938 2.01923V3.00853L9.41964 8.11664ZM10.2589 9.19676L18 3.68495V2.01923C18 0.904053 17.0556 0 15.8906 0H2.10938C0.944414 0 6.03497e-07 0.904053 6.03497e-07 2.01923V3.68495L7.74107 9.19676C8.48832 9.72883 9.51168 9.72883 10.2589 9.19676Z"
                    fill="#515151"
                  />
                  <path
                    d="M16.5938 6.36392V11.9808C16.5938 12.3519 16.2783 12.6538 15.8906 12.6538H2.10938C1.72167 12.6538 1.40625 12.3519 1.40625 11.9808V6.36392L0 5.36265V11.9808C0 13.0942 0.946266 14 2.10938 14H15.8906C17.0537 14 18 13.0942 18 11.9808V5.36265L16.5938 6.36392Z"
                    fill="#515151"
                  />
                </svg>
              </div>
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-black text-white py-2 rounded-md"
            >
              {loading ? "Checking..." : "Continue"}
            </button>
          </form>
          {error && <div style={styles.error}>{error}</div>}
        </div>
      </div>
      <div className="hidden lg:block">
        <Footer />
      </div>
    </div>
  );
};

const styles = {
  error: {
    width: "100%",
    marginTop: "20px",
    padding: "10px",
    backgroundColor: "#FFEEEE",
    color: "#D8000C",
    border: "1px solid #D8000C",
    borderRadius: "4px",
  },
};

export default ReservationCheck;
